import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';

import './RemoveModal.css';

type RemoveModalProps = {
  onRemove: () => void;
  onClose: () => void;
};

export const RemoveModal: React.ForwardRefExoticComponent<
  RemoveModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ onClose, onRemove }, forwardedRef) => {
  const [t] = useLanguage();

  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  return (
    <Modal ref={modalRef}>
      <h3 className="modal-title">{t('addresses.removeModalTitle')}</h3>
      <p className="modal-description">
        {t('addresses.removeModalDescription')}
      </p>
      <div className="modal-button-container">
        <Button onClick={onRemove} label={t('addresses.delete')} isPrimary />
        <div className="remove-address-modal--exit-button">
          <Button onClick={onClose} label={t('addresses.close')} />
        </div>
      </div>
    </Modal>
  );
});
